export function criterionSelector() {
  return {
    restrict: 'E',
    template: require('./criterion-selector.directive.html'),
    scope: {
      selector: '=' // A selector object from metric.controller.js
    }
  };
}

